import React from 'react';
import { ReactComponent as Play } from '../../assets/images/play.svg';
import { ReactComponent as Pause } from '../../assets/images/pause.svg';
import { ReactComponent as Next } from '../../assets/images/next.svg';
import { ReactComponent as Prev } from '../../assets/images/prev.svg';
import { ReactComponent as ForwardTen } from '../../assets/images/forwardTen.svg';
import { ReactComponent as BackwardTen } from '../../assets/images/backwardTen.svg';

interface IProps {
  isPlaying: boolean;
  onPlayPauseClick: (value: boolean) => void;
  onPlayClick: () => void;
  onPrevClick: () => void;
  onNextClick: () => void;
  forwardClick: () => void;
  backwardClick: () => void;
}

const AudioControls = ({
  isPlaying,
  onPlayPauseClick,
  onPlayClick,
  onPrevClick,
  onNextClick,
  forwardClick,
  backwardClick,
}: IProps) => (
  <div className="audio-controls">
    <button
      type="button"
      className="prev"
      aria-label="Previous"
      onClick={onPrevClick}
    >
      <Prev className="prev-icon" />
    </button>
    <button
      type="button"
      className="prev"
      aria-label="Previous"
      onClick={backwardClick}
    >
      <BackwardTen className="prev-ten-icon" />
    </button>
    {isPlaying ? (
      <button
        type="button"
        className="pause"
        // onClick={() => onPlayPauseClick(false)}
        onClick={onPlayClick}
        aria-label="Pause"
      >
        <Pause className="play-icon" />
      </button>
    ) : (
      <button
        type="button"
        className="play"
        // onClick={() => onPlayPauseClick(true)}
        onClick={onPlayClick}
        aria-label="Play"
      >
        <Play className="play-icon" />
      </button>
    )}
    <button
      type="button"
      className="next"
      aria-label="Next"
      onClick={forwardClick}
    >
      <ForwardTen className="next-ten-icon" />
    </button>
    <button
      type="button"
      className="next"
      aria-label="Next"
      onClick={onNextClick}
    >
      <Next className="next-icon" />
    </button>
  </div>
);

export default AudioControls;
